// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BnJC","fullView":"styles_fullView__3koye"};